import React, { createContext, useContext, useState } from "react";
import { FirebaseContext } from "./FirebaseContext";
import { SessionContext } from "../contexts/SessionContext";

const RemoteGitActionsContext = createContext();

export const RemoteGitActionsProvider = ({ children }) => {
  const { getFreshToken } = useContext(FirebaseContext);
  const { getEndpointUrl } = useContext(SessionContext);
  const [gitLogs, setGitLogs] = useState([]);

  const fetchGitLogs = async (repoName) => {
    try {
      const freshToken = await getFreshToken();
      const response = await fetch(getEndpointUrl() + "/getGitLogs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${freshToken}`,
        },
        body: JSON.stringify({ repoName }),
      });
      if (!response.ok) throw new Error("Error fetching git logs.");
      const data = await response.json();
      setGitLogs(data.commits);
      return data.commits;
    } catch (error) {
      console.error("Error fetching git logs:", error);
      return [];
    }
  };

  const clearLogs = () => setGitLogs([]);

  return (
    <RemoteGitActionsContext.Provider
      value={{
        fetchGitLogs,
        gitLogs,
        clearLogs,
      }}
    >
      {children}
    </RemoteGitActionsContext.Provider>
  );
};

export const useRemoteGitActionsContext = () =>
  useContext(RemoteGitActionsContext);
